// Which matter record the user chose or opened. Values are the product names, not the
// short ids the selection card and the sidebar use internally.
export enum MatterRecordType {
  Timeline = 'timeline',
  MedicalChronology = 'medical_chronology',
  MedicalBillingSummary = 'medical_billing_summary',
}

// Where an existing matter record was opened from. The collapsed sidebar menu is the same
// link as the expanded sidebar, so both use Sidebar.
export enum MatterRecordEntryPoint {
  Sidebar = 'sidebar',
  ModalChip = 'modal_chip',
}
